import { Button, Card, Conditional } from '@payaca/ambrosia';

import UntitledIcon from '@payaca/untitled-icons';
import React, { FC, PropsWithChildren } from 'react';

export interface IProps {
  onRemove?: () => void;
  thumbnailUrl: string;
  fileName: string;
}

const ProjectFileCard: FC<IProps> = (props) => {
  const { onRemove, thumbnailUrl, fileName } = props;

  return (
    <Card
      sizeVariant="lg"
      className="relative flex aspect-square items-center justify-center overflow-hidden"
    >
      <img src={thumbnailUrl} alt={fileName} className="h-auto w-full" />

      <Conditional condition={!!onRemove}>
        <Button
          className="!absolute right-2 top-2"
          variant={'ghost'}
          colour={'grey'}
          size={'xs'}
          onClick={onRemove}
        >
          <UntitledIcon name="x-close" className="h-3 w-3" />
        </Button>
      </Conditional>
    </Card>
  );
};

const ProjectFileCardWrapper = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren
>((props, ref) => {
  const { children } = props;

  return (
    <div
      className="grid grid-cols-3 gap-4 sm:grid-cols-4 md:grid-cols-6"
      ref={ref}
    >
      {children}
    </div>
  );
});

export default Object.assign(ProjectFileCard, {
  Wrapper: ProjectFileCardWrapper,
});
